import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {CodeList, CodeListId} from './types';
import {sortCodeList} from './functions';
import {mapCodeListDto} from './mappers/mapCodeListDto';

export const codelistApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getCodelist: build.query<
      CodeList,
      {
        id: CodeListId;
        language: string;
      },
      Schemas.CodelistDto
    >({
      keepUnusedDataFor: 60 * 60 * 8,
      query: ({id, language}) => {
        return {
          url: '/codelist/v2',
          params: {
            id: id.toUpperCase(),
            language,
          },
          headers: {
            'Accept-Language': language,
          },
        };
      },
      transformResponse: response => sortCodeList(mapCodeListDto(response)),
    }),
  }),
});

export const {useGetCodelistQuery} = codelistApi;
